import { ReactNode, useLayoutEffect, useState } from "react";
import AuthScreen, { AuthData } from "../components/common/AuthScreen";
import { runInAction } from "mobx";
import { observer } from "mobx-react";

const PageWrapper = ({ page }: { page: ReactNode }) => {
  const [show, setShow] = useState(false);
  useLayoutEffect(() => {
    let user = localStorage.getItem("auth-user");
    if (user) {
      user = JSON.parse(user);
      if (user?.length) {
        runInAction(() => {
          AuthData.user = true;
        });
      }
    }

    setShow(true);
  }, []);

  if (!show) return <></>;

  if (!AuthData.user) return <AuthScreen />;

  return <>{page}</>;
};

export default observer(PageWrapper);
